import React from "react";
import { Box, Typography, Card, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { cardStyles, iconStyles } from "../../styles/CustomCss";

const ActionCard = ({
  title,
  description,
  icon: Icon,
  bgColor,
  navigateTo,
}) => {
  const navigate = useNavigate();

  return (
    <Grid item xs={12} sm={6} md={3}>
      <Card
        onClick={() => navigate(navigateTo)}
        sx={{
          ...cardStyles,
          backgroundColor: bgColor,
          "&:hover": {
            boxShadow: 3,
            transform: "scale(1.05)",
          },
        }}
      >
        <Icon sx={{ ...iconStyles }} />
        <Box>
          <Typography variant="h6">{title}</Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </Box>
      </Card>
    </Grid>
  );
};

export default ActionCard;
